const API_URL = 'https://kubuku.id/api/lsp/index.php'
// const API_URL = 'http://localhost:8001/api-dashboard/index.php'
// const API_URL = 'http://localhost:8001/dashboard_perpus/index.php'

const SSO = API_URL + '/sso'
const USERSIGNIN = API_URL + '/userSignIn'
const JMLPERPUS = API_URL + '/jumlahPerpus'
const JMLPENGGUNA = API_URL + '/jumlahPengguna'
const JMLKOLEKSI = API_URL + '/jumlahKoleksi'
const KOLEKSITERBANYAK = API_URL + '/koleksiTerbanyak'
const PENGGUNATERBANYAK = API_URL + '/penggunaTerbanyak'
const DURASIBACA = API_URL + '/durasiBaca'
const KOTA = API_URL + '/kota'
const KECAMATAN = API_URL + '/kecamatan'
const JENJANG = API_URL + '/tipeMitra'
const MITRA = API_URL + '/mitra'
const PROFILE = API_URL + '/profile'
const PERMINTAANBUKU = API_URL + '/getPermintaanMitra'
const JMLDURASIJAM = API_URL + '/jumlahDurasiBaca'
const JMLKOLEKSIDIBACA = API_URL + '/jumlahKontendiBaca'
const JMLPEMBACA = API_URL + '/jumlahPembaca'
const PEMBACATERBANYAK = API_URL + '/pembacaTerbanyak'
const KOLEKSITERBACATERBANYAK = API_URL + '/koleksiTerbacaTerbanyak'
const DURASITERLAMA = API_URL + '/durasiTerlama'
const JUMLAHPENGUNJUNG = API_URL + '/jumlahPengunjung'
const PENGUNJUNGTERBANYAK = API_URL + '/pengunjungTerbanyak'
const DURASIPENGGUNA = API_URL + '/lineChartPengguna'
const DURASIKOLEKSI = API_URL + '/lineChartKoleksi'
const DURASIKUNJUNGAN = API_URL + '/lineChartKunjungan'
const DURASIPEMBACA = API_URL + '/lineChartPembaca'
const DURASIKOLEKSIDIBACA = API_URL + '/lineChartKoleksidibaca'
const DOWNLOADPENGGUNA = API_URL + '/downloadPengguna'
const DOWNLOADPEMBACA = API_URL + '/downloadPembaca'
const DOWNLOADPENGUNJUNG = API_URL + '/downloadPengunjung'
const DOWNLOADDURASI = API_URL + '/downloadDurasi'
const DOWNLOADKOLEKSI = API_URL + '/downloadKoleksi'
const DOWNLOADDIBACA = API_URL + '/downloadDibaca'
const DETAILPEMBACA = API_URL + '/detailChartPembaca'
const DETAILPENGGUNA = API_URL + '/detailChartPengguna'
const DETAILKOLEKSIDIBACA = API_URL + '/detailChartKoleksiDibaca'
const DETAILDURASI = API_URL + '/detailChartDurasi'
const DETAILKUNJUNGAN = API_URL + '/detailChartKunjungan'
const DETAILKONTENDIBACAPermitra = API_URL + '/detailKontenDibacaPerMitra'
const GETMITRA = API_URL + '/getMitra'
const DOWNLOADDETAILPENGGUNA = API_URL + '/downloadDetailChartPengguna'
const DOWNLOADDETAILPEMBACA = API_URL + '/downloadDetailChartPembaca'
const DOWNLOADDETAILKOLEKSIDIBACA = API_URL + '/downloadDetailChartKoleksiDibaca'
const DOWNLOADDETAILKONTENPERMITRA = API_URL + '/downloadDetailKontenDibacaPerMitra'
const DOWNLOADDETAILDURASI = API_URL + '/downloadDetailChartDurasi'
const DOWNLOADDETAILKUNJUNGAN = API_URL + '/downloadDetailChartKunjungan'


const methodGet = async (url, headers) => {
  try {
    let postData = {
      method: 'get',
      headers: headers,
    }
    const response = await fetch(url, postData)
    const json = await response.json()
    return json
  } catch (error) {
    let errorObj = {
      code: 500,
      msg: 'Network Error',
    }
    return errorObj
  }
}

export {
  SSO,
  USERSIGNIN,
  JMLPERPUS,
  JMLPENGGUNA,
  JMLKOLEKSI,
  KOLEKSITERBANYAK,
  PENGGUNATERBANYAK,
  DURASIBACA,
  KOTA,
  KECAMATAN,
  JENJANG,
  MITRA,
  PROFILE,
  JMLDURASIJAM,
  JMLKOLEKSIDIBACA,
  JMLPEMBACA,
  PERMINTAANBUKU,
  PEMBACATERBANYAK,
  KOLEKSITERBACATERBANYAK,
  DURASITERLAMA,
  JUMLAHPENGUNJUNG,
  PENGUNJUNGTERBANYAK,
  DURASIPENGGUNA,
  DURASIKOLEKSI,
  DURASIKUNJUNGAN,
  DURASIPEMBACA,
  DURASIKOLEKSIDIBACA,
  DOWNLOADPENGGUNA,
  DOWNLOADPEMBACA,
  DOWNLOADPENGUNJUNG,
  DOWNLOADDURASI,
  DOWNLOADKOLEKSI,
  DOWNLOADDIBACA,
  DOWNLOADDETAILPENGGUNA,
  DOWNLOADDETAILPEMBACA,
  DOWNLOADDETAILKOLEKSIDIBACA,
  DOWNLOADDETAILKONTENPERMITRA,
  DOWNLOADDETAILDURASI,
  DOWNLOADDETAILKUNJUNGAN,
  DETAILPEMBACA,
  DETAILKOLEKSIDIBACA,
  DETAILPENGGUNA,
  DETAILKUNJUNGAN,
  DETAILDURASI,
  DETAILKONTENDIBACAPermitra,
  GETMITRA,
  methodGet,
}
